module.exports = "/images/SuppImg2.jpg";